export default "/images/54150719fa63684d02b5216e3b0264b4.avif";